import React from 'react';

const Icon = (props) => {
    const {
        className,
        title = ""
    } = props;

    return (
        <i className={className} title={title} />
    );
}

export default Icon;